/**
 * Lists Screen
 *
 * Tabbed layout with three scopes: My Lists, Shared, and Public.
 * Each tab has its own search bar and lazy-loads data on first visit.
 */

import { ScreenHeader } from '@/components/layout/screen-header';
import { PageTitle } from '@/components/seo/page-title';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CreateListModal } from '@/features/lists/components/create-list-modal';
import { MyListsTab } from '@/features/lists/components/my-lists-tab';
import { PublicListsTab } from '@/features/lists/components/public-lists-tab';
import { SharedListsTab } from '@/features/lists/components/shared-lists-tab';
import Ionicons from '@expo/vector-icons/Ionicons';
import React, { useState } from 'react';
import { Text, View } from 'react-native';

export default function ListsScreen() {
  const [createModalVisible, setCreateModalVisible] = useState(false);

  return (
    <View className="flex-1">
      <PageTitle title="Lists" />
      <ScreenHeader
        title="Lists"
        showBackButton
        rightSlot={
          <Button
            variant="ghost"
            size="sm"
            onPress={() => setCreateModalVisible(true)}
            accessibilityLabel="Create New list"
          >
            <Ionicons name="add" size={24} className="text-primary" />
            <Text className="text-primary">New List</Text>
          </Button>
        }
      />

      <Tabs defaultValue="my-lists" className="flex-1">
        <TabsList>
          <TabsTrigger value="my-lists" title="My Lists" />
          <TabsTrigger value="shared" title="Shared" />
          <TabsTrigger value="public" title="Public" />
        </TabsList>

        <TabsContent value="my-lists" className="flex-1">
          <MyListsTab onCreateList={() => setCreateModalVisible(true)} />
        </TabsContent>
        <TabsContent value="shared" className="flex-1">
          <SharedListsTab />
        </TabsContent>
        <TabsContent value="public" className="flex-1">
          <PublicListsTab />
        </TabsContent>
      </Tabs>

      <CreateListModal
        visible={createModalVisible}
        onClose={() => setCreateModalVisible(false)}
      />
    </View>
  );
}
